'use client'
import React, {useState} from 'react';
import styled from "styled-components";
import {Col, Container, Form, Modal, Row} from "react-bootstrap";
import reactHtmlParser from "react-html-parser";
import Button from "@/components/Button";

import {Img} from "../Img";
import Title from "@/components/Title";
import {BlueArrow, hover, primary} from "@/styles/globalStyleVars";
const AssetService = ({offset,btn,btnSrc,listing,files,sectionId,img,pdTop,pdBottom,reverse,title,desc,text,address,phone,mapLink,revealClass,short_desc,bgColor}) => {

    return (
        <StyledService className={`asset-seal ${pdTop} ${pdBottom} ${bgColor}`} reverse={reverse} id={`${sectionId}`} >
            <Container className={` ${reverse ? 'reverse' : ''}`}>
                {
                    reverse==="yes" ?
                        <Row className={'reverse-row'}>
                            <Col sm={{span: 6}} className='asset-seal__text'>
                                {
                                    title &&
                                    <Title text={title} margin={'0 0 30px 0'} fontSize={'40'} lineHeight={'50'}/>
                                }
                                <div className={'description'}>

                                    <p>{reactHtmlParser(desc)}</p>

                                </div>

                                {
                                    listing?.length > 0 &&
                                    <ul>
                                        {
                                            listing?.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <img src={item?.cdn_path} alt=""/>
                                                        <p>{reactHtmlParser(item?.short_title)}</p>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }


                                <div className="button-group">
                                    {
                                        files?.length > 0 &&
                                        <div className="download-btns">
                                            <ul>
                                                {
                                                    files && files?.length > 0 &&
                                                    files?.map((item, index) => {
                                                        return (
                                                            <li key={index}><a target={'_blank'} href={item?.full_path}>
                                                                <svg width="30px" height="30px" viewBox="0 0 24 24"
                                                                     fill="none"
                                                                     xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M12 2a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V3a1 1 0 0 1 1-1zM5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z"
                                                                        fill="#638297"/>
                                                                </svg>
                                                                <span>{item?.short_title}</span>
                                                            </a></li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    }
                                    {
                                        btnSrc &&
                                        <Button text={'Download Forms'} background={'transparent'}
                                                border={'1px solid #638297'} hoverBackground={primary}
                                                 arrowfilter={BlueArrow} color={hover}
                                                hoverborder={'1px solid #978C21'}
                                                src={btnSrc}
                                        />
                                    }


                                </div>


                            </Col>
                            <Col sm={{span: 6}} className='asset-seal__img'>
                                <div className={`asset-seal__img__inner`}>
                                    <Img layout={'responsive'} src={img} alt=""/>
                                </div>
                            </Col>
                        </Row>
                        :
                        <Row className={'not-reverse'}>
                            <Col sm={6} className='asset-seal__img'>

                                <div className={`asset-seal__img__inner`}>
                                    <Img src={img} alt=""/>
                                </div>
                            </Col>

                            <Col sm={{span: 6}} className='asset-seal__text'>
                                {
                                    title &&
                                    <Title text={title} margin={'0 0 30px 0'} fontSize={'40'} lineHeight={'50'}/>
                                }
                                <div className={'description'}>

                                    <p>{reactHtmlParser(desc)}</p>

                                </div>
                                {
                                    listing?.length > 0 &&
                                    <ul>
                                        {
                                            listing?.map((item, index) => {
                                                return (
                                                    <li key={index}>
                                                        <img src={item?.cdn_path} alt=""/>
                                                        <p>{reactHtmlParser(item?.short_title)}</p>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }


                                <div className="button-group">
                                    {
                                        files?.length > 0 &&
                                        <div className="download-btns">
                                            <ul>
                                                {
                                                    files && files?.length > 0 &&
                                                    files?.map((item, index) => {
                                                        return (
                                                            <li key={index}><a target={'_blank'} href={item?.full_path}>
                                                                <svg width="30px" height="30px" viewBox="0 0 24 24"
                                                                     fill="none"
                                                                     xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M12 2a1 1 0 0 1 1 1v10.586l2.293-2.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V3a1 1 0 0 1 1-1zM5 17a1 1 0 0 1 1 1v2h12v-2a1 1 0 1 1 2 0v2a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z"
                                                                        fill="#638297"/>
                                                                </svg>
                                                                <span>{item?.short_title}</span>
                                                            </a></li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    }
                                    {
                                        btnSrc &&
                                        <Button text={'Download Forms'} background={'transparent'}
                                                border={'1px solid #638297'} hoverBackground={primary}
                                                arrowfilter={BlueArrow} color={hover}
                                                hoverborder={'1px solid #978C21'}
                                                src={btnSrc}
                                        />
                                    }


                                </div>
                            </Col>
                        </Row>
                }

            </Container>

        </StyledService>
    );
};

const StyledService = styled.section`
    background-color: #F6F6F6;

    &.bg-color {
        background-color: rgb(245, 245, 245);
    }

    &:last-child {
        padding-bottom: 150px;
        @media (max-width: 767px) {
            padding-bottom: 80px;
        }
    }
    
    .button-group{
        display: flex;
        gap: 30px;
        margin-top: 40px;
        flex-direction: column;
        
        .download-btns{
            ul{
                display: flex;
                gap: 20px;
                margin-top: 0 !important;
                flex-direction: column;
                li{
                    margin-bottom: 0 !important;
                    a{
                        text-decoration: underline;
                        color: #3C3C3B;
                        font-size: 18px;
                        @media(min-width: 1920px) {
                            font-size: 18px;
                        }
                        svg{
                            margin-right: 15px;
                            path{
                                transition: 0.3s ease-in-out;
                            }
                        }
                        &:hover{
                            svg{
                                path{
                                    fill: #638297;
                                }
                            }
                        }
                    }
                }
            }
        }
        
        @media(max-width: 767px){
            flex-direction: column;
            align-items: flex-start;
        }
        
    }

    .container-fluid {
            // padding-right: ${props => props.offset ? props.offset : '115'}px;

        &.reverse {
                // padding-left: ${props => props.offset ? props.offset : '90'}px;

            .security-seal__text {
                padding-left: 0;
                padding-right: 70px;
            }

            @media (max-width: 992px) {
                .reverse-row {
                    flex-direction: column-reverse;
                }
            }
        }
    }

    .asset-seal__img {
        padding-right: 35px;

        .title {
            display: none;
        }

        &__inner {
            padding-top: calc(600 / 570 * 100%);
            position: relative;
            overflow: hidden;
            //min-height: 100%;
            border-radius: 10px;
            img {
                object-fit: cover;
            }
        }

        @media (max-width: 767px) {
            .title {
                display: block;
      }
    }
  }
  .reverse-row{
    .asset-seal__text{
      padding-right: 35px;
    }
    .asset-seal__img{
      padding-left: 35px;
    }
    @media(max-width: 767px){
      flex-direction: column-reverse;
    }
  }

  .asset-seal__text {
      ul{
          margin-top: 40px;
      }
    p {
      color: #3C3C3B;
        font-weight: 500;
      :last-child{
        margin-bottom: 0px;
      }
    }
    h3{
      margin-top: 60px;
      margin-bottom: 20px;
      font-weight: 300;
      font-family: 'pp-fragment-serif-2',Poppins,Arial, Helvetica, freesans, sans-serif;
      color: #2A2627;
    }
    .address{
      a{
        font-size: 16px;
        line-height: 24px;
        display: block;
        width: max-content;
      }
      .map-address{
        margin-bottom: 20px;
        p{
          margin-bottom: 0;
        }
      }
    }
    .title{
      display: block;
    }
      ul{
          
          li{
              display: flex;
              gap: 15px;
              align-items: center;
              
              p{
                  font-size: 18px;
                  line-height: 18px;
                  font-weight: 400;
                  margin-top: 5px;
              }
              &:not(:last-child){
                  margin-bottom: 25px;
              }
          }
      }
    @media(max-width: 767px){
      .title{
          margin-bottom: 20px;
        h2{
            font-size: 28px !important;
            line-height: 36px !important;
        }
      }
    }
  }

  @media(min-width: 768px){
    .asset-seal__text{
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      //justify-content: center;
      padding-left: 35px;
    }
  }
  @media (max-width: 991px) {
    .container-fluid{
      padding-right: 15px !important;
      padding-left: 15px !important;
    }
    .asset-seal__img {
      min-width: 100%;
      padding-left: 15px !important;
      padding-right: 15px !important;
        overflow: hidden;
    }   
    .asset-seal__text {
      min-width: 100%;
      margin-top: 40px;
      margin-left: 0;
      padding-left: 15px !important;
      padding-right: 15px !important;
    }
  }

  @media (max-width: 767px) {
    img{
      border-radius: 0px;
    }
    .dc-btn {
      margin-top: 30px;
    }
  }
    
    .description{
        ul{
            margin-top: 40px;
           li{
               position: relative;
               padding-left: 20px;
               &:after{
                   content: '';
                   position: absolute;
                   top: 7px;
                   left: 0;
                   width: 8px;
                   height: 8px;
                   background-color: ${hover};
                   border-radius: 50%;
               }
           } 
        }
    }
    
    @media(max-width: 991px) and (min-width: 768px){
        .reverse-row{
            .asset-seal__text{
                margin-bottom: 60px;
                margin-top: 0;
            }
        }
        .not-reverse{
            flex-direction: column-reverse;
            .asset-seal__text{
                margin-bottom: 60px;
                margin-top: 0;
            }
        }
    }


`;
export default AssetService;
